import React from 'react';
import { DollarSign, ShoppingBag, Users, Package, Star } from 'lucide-react';

const LiveEcosystemOverview = ({ kpis, loading }) => {
  const metrics = [
    {
      id: 1,
      title: "Today's Revenue",
      value: kpis ? `£${Number(kpis.today_revenue || 0).toLocaleString('en-GB', { minimumFractionDigits: 2 })}` : '£0.00',
      growth: kpis ? `Total: £${Number(kpis.total_revenue || 0).toLocaleString('en-GB', { minimumFractionDigits: 2 })}` : 'Live revenue',
      icon: DollarSign,
    },
    {
      id: 2,
      title: 'Total Orders',
      value: kpis ? Number(kpis.total_orders || 0).toLocaleString() : '0',
      growth: 'Real-time orders placed',
      icon: ShoppingBag,
    },
    {
      id: 3,
      title: 'Total Customers',
      value: kpis ? Number(kpis.total_customers || 0).toLocaleString() : '0',
      growth: 'Registered store accounts',
      icon: Users,
    },
    {
      id: 4,
      title: 'Products Sold',
      value: kpis ? `${kpis.total_units_sold || 0} Units` : '0 Units',
      growth: 'Items delivered & active',
      icon: Package,
    },
    {
      id: 5,
      title: 'Store Rating',
      value: kpis ? `${kpis.average_rating || '5.0'} / 5.0` : '5.0 / 5.0',
      growth: `${kpis?.reviews_count || 0} Verified Reviews`,
      icon: Star,
    },
  ];

  return (
    <div className="ecosystem-card">
      <h2 className="ecosystem-header" style={{ textAlign: 'left', marginBottom: '16px' }}>
        STORE PERFORMANCE OVERVIEW
      </h2>

      <div className="ecosystem-cards-grid">
        {metrics.map((m) => {
          const IconComp = m.icon;
          return (
            <div key={m.id} className="radial-node-box" style={{ width: '100%' }}>
              <div className="node-icon-circle">
                <IconComp size={20} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className="node-title-sub">{m.title}</span>
                <div className="node-value-big">{m.value}</div>
                <span className="node-growth-text">{m.growth}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LiveEcosystemOverview;
